module.exports = __webpack_public_path__ + "resources/img/img_i_onenet2_m_jp.33007f850fb54f183e9f51d9426689f4.png";